import { Calculator, Calendar, DollarSign, Loader2 } from "lucide-react";
import { periodicities } from "../../../../../constants/options"
// Componente para configuración de periodicidad
const PeriodicityConfig = ({ 
  currentPeriodicity, 
  currentAmount, 
  newPeriodicity, 
  newAmount, 
  onPeriodicityChange, 
  onAmountChange, 
  onCalculateNewQuotas,
  isCalculating,
  isDisabled = false
}) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    <h3 className="text-lg font-bold text-[#09274A] mb-4">Configuración de Periodicidad</h3>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Configuración Actual */}
      <div className="bg-gray-50 rounded-lg p-4">
        <h4 className="font-semibold text-[#09274A] mb-3">Actual</h4>
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Periodicidad</label>
            <div className="text-lg font-medium text-gray-800">{currentPeriodicity}</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Monto</label>
            <div className="text-lg font-medium text-gray-800">{currentAmount} UF</div>
          </div>
        </div>
      </div>

      {/* Nueva Configuración */}
      <div className="bg-blue-50 rounded-lg p-4">
        <h4 className="font-semibold text-[#09274A] mb-3">Nueva Configuración</h4>
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <Calendar className="inline mr-1" size={16} />
              Periodicidad
            </label>
            <select
              value={newPeriodicity}
              onChange={(e) => onPeriodicityChange(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0488AF] focus:border-transparent"
            >
               {periodicities
                .filter(option => option.value !== currentPeriodicity)
                .map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <DollarSign className="inline mr-1" size={16} />
              Monto (UF)
            </label>
            <input
              type="number"
              step="any" // permite decimales
              min="0"
              value={newAmount}
              onChange={(e) => onAmountChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === ',' || e.key === 'e' || e.key === 'E') {
                  e.preventDefault();
                }
              }}
              className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0488AF] focus:border-transparent"
              placeholder="Ingrese el monto (ej: 10.5)"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="mt-4 text-center">
      <button
        onClick={onCalculateNewQuotas}
        disabled={isCalculating || isDisabled}
        className="flex items-center gap-2 px-6 py-2 bg-[#0488AF] text-white rounded-lg hover:bg-[#037299] transition-colors mx-auto disabled:opacity-50"
      >
        {isCalculating ? (
          <Loader2 className="animate-spin" size={16} />
        ) : (
          <Calculator size={16} />
        )}
        {isCalculating ? 'Calculando...' : 'Calcular Nuevas Cuotas'}
      </button>
    </div>
  </div>
);

export default PeriodicityConfig;